// ─────────────────────────────────────────────
//  HowItWorks — public explainer page
// ─────────────────────────────────────────────
import Nav from "../components/Nav";

const STEPS = [
  { num:"01", icon:"⚙️", who:"You (merchant)", color:"#FF6B35",
    title:"Set up in 5 minutes",
    desc:"Enter your business name, choose which platforms to post to, and we generate your unique QR code. Print it on your receipts — done." },
  { num:"02", icon:"📱", who:"Your customer", color:"#FFBE0B",
    title:"Customer scans the QR",
    desc:"After their visit, they scan the code. Their phone opens a page with your business name, location, and date already filled in. No app needed." },
  { num:"03", icon:"⭐", who:"Your customer", color:"#4ECDC4",
    title:"Taps stars + quick tags",
    desc:"They tap 1-5 stars, choose from quick-tags like 'Great service' or write a sentence. The whole thing takes 20 seconds." },
  { num:"04", icon:"🚀", who:"JiffyReview", color:"#A8DAFF",
    title:"Posted to all platforms instantly",
    desc:"The review is automatically posted to Google, Yelp, and TripAdvisor simultaneously. Low-star reviews are privately routed to you first." },
];

export default function HowItWorks({ goHome, goPricing, goOnboard }) {
  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0f", fontFamily:"'Plus Jakarta Sans', sans-serif", color:"#f0ede8" }}>

      <Nav onHome={goHome} onHow={() => {}} onPricing={goPricing} onGetStarted={goOnboard} />

      <div style={{ maxWidth:800, margin:"0 auto", padding:"70px 40px" }}>
        <div style={{ textAlign:"center", marginBottom:64 }}>
          <div style={{ fontSize:11, color:"#FF6B35", fontWeight:700, letterSpacing:"0.12em", marginBottom:12 }}>HOW IT WORKS</div>
          <h1 style={{ fontSize:"clamp(30px,5vw,52px)", fontWeight:900, letterSpacing:"-0.04em", margin:"0 0 16px" }}>
            From receipt to review<br />in 20 seconds
          </h1>
          <p style={{ color:"rgba(255,255,255,0.4)", fontSize:16, fontWeight:300, lineHeight:1.7 }}>
            Three steps. No app download. No account creation. Just a scan.
          </p>
        </div>

        <div style={{ display:"flex", flexDirection:"column" }}>
          {STEPS.map((s, i) => (
            <div key={i} style={{ display:"flex", gap:24, padding:"36px 0", borderBottom: i < STEPS.length - 1 ? "1px solid rgba(255,255,255,0.06)" : "none" }}>
              <div style={{ width:56, height:56, borderRadius:16, background:`${s.color}22`, border:`1.5px solid ${s.color}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:26, flexShrink:0 }}>
                {s.icon}
              </div>
              <div style={{ flex:1 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:6 }}>
                  <span style={{ fontFamily:"monospace", fontSize:11, color:s.color, fontWeight:700 }}>{s.num}</span>
                  <span style={{ fontSize:10, color:"rgba(255,255,255,0.25)", background:"rgba(255,255,255,0.06)", padding:"3px 8px", borderRadius:6 }}>{s.who}</span>
                </div>
                <div style={{ fontSize:20, fontWeight:800, marginBottom:8, letterSpacing:"-0.02em" }}>{s.title}</div>
                <div style={{ fontSize:14, color:"rgba(255,255,255,0.5)", lineHeight:1.7, fontWeight:300 }}>{s.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign:"center", marginTop:56 }}>
          <button onClick={goOnboard} style={{ padding:"16px 36px", borderRadius:14, border:"none", background:"linear-gradient(135deg,#FF6B35,#FFBE0B)", color:"white", fontSize:16, fontWeight:800, cursor:"pointer", fontFamily:"inherit" }}>
            Set up my QR code →
          </button>
        </div>
      </div>
    </div>
  );
}
